import React, { Fragment, useEffect } from "react";
import {
  Button,
  Card,
  Typography,
  Box,
  Container,
  Stack,
  Grid,
} from "@mui/material";
import "./Plans.css";
import KidMonitoringApp from "../../assets/images/KidMonitoringApp.svg";
import UpgradeorDowngrade from "../../assets/images/UpgradeorDowngrade.svg";
import OnDemandBackups from "../../assets/images/OnDemandBackups.svg";
import SafeSecureEnvironment from "../../assets/images/SafeSecureEnvironment.svg";
import NavBarLandingPage from "../pages/NavBarLandingPage";
import FooterLandingpage from "../pages/FooterLandingpage";
import { useResponsive } from "../../hooks/use-responsive";
import axios from "axios";
import AMD from "../../assets/images/AMD.svg";
import GB from "../../assets/images/GB.svg";
import CPU from "../../assets/images/CPU.svg";
import Windows from "../../assets/images/Windows.svg";
import GBPS from "../../assets/images/GBPS.svg";
import GPU from "../../assets/images/TotalGPU.png";

const Plans = () => {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const GET_PLANS = `${SERVER_URI}/getPlans`;

  const mdUp = useResponsive("up", "md");

  const handlePlanSelect = (planName) => {
    sessionStorage.setItem("selectedPlan", planName);
    window.location.href = "/paymenthome";
  };
  const handleFreeTrialClick = () => {
    const selectedPlan = "Free Trial"; // Only store the plan name

    sessionStorage.setItem("selectedPlan", selectedPlan);
    window.location.href = "/paymenthome"; // Redirect to the payment plan page
  };

  useEffect(() => {
    const hash = window.location.hash; // Get the hash from the URL
    if (hash) {
      const targetElement = document.getElementById(hash.substring(1));
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  const [plans, setPlans] = React.useState([]);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await axios.get(GET_PLANS);
        setPlans(response.data);
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    };

    fetchPlans();
  }, []);
  return (
    <Fragment>
      {/* <Box> */}
      <NavBarLandingPage />
      {/* </Box> */}
      <Container
        maxWidth={false}
        sx={{
          backgroundColor: "#F1F1F1",
          padding: { xs: "20px 20px", sm: "44px 64px", md: "42px 64px" },
        }}
      >
        <Typography
          className="heading3"
          sx={{
            textAlign: "center",
          }}
          id="details"
        >
          CHOOSE THE{" "}
          <span style={{ color: "blue" }}>
            <i> PLAN </i>
          </span>
          &nbsp;THAT FITS YOUR NEEDS.
        </Typography>
        <Box
          sx={{
            display: "grid",
            rowGap: { xs: 3, sm: 5, md: 5 },
            columnGap: 4,
            mt: 4,
            gridTemplateColumns: {
              xs: "repeat(1, 1fr)", // iPhone Mini (small screens)
              sm: "repeat(2, 1fr)", // For screens like iPad mini (768px)
              md: "repeat(3, 1fr)",
            },
          }}
        >
          {plans.slice(0, 3).map((plan) => (
            <Card
              sx={{
                borderRadius: 5,
                p: "48px 18px",
                border: "2px solid #1D53E7",
                zIndex: 1,
              }}
            >
              <Typography
                className="planTitle"
                sx={{
                  textAlign: "center",
                }}
              >
                {plan.planName}
              </Typography>
              <Typography
                className="subText"
                sx={{
                  textAlign: "center",
                }}
              >
                {plan.description}
              </Typography>

              <Typography
                className="priceAmt"
                sx={{
                  textAlign: "center",
                  mt: 1,
                }}
              >
                ₹ {plan.amount}
                <span className="priceMonth">/monthly</span>
              </Typography>

              <Stack
                direction="column"
                spacing={1}
                mt={1}
                mb={1}
                justifyContent="center"
                alignItems="center"
              >
                {plan.planName === "Enthusiast" && (
                  <Stack direction="row" spacing={2} width="100%">
                    <Button
                      onClick={() => {
                        handlePlanSelect(plan.planName, "Free Trial");
                        handleFreeTrialClick();
                      }}
                      variant="contained"
                      className="btnEnthusiast"
                      fullWidth
                      sx={{
                        backgroundColor: "white",
                        p: {
                          xs: "10px 8px",
                          md: "10px 8px",
                          sm: "10px 15px",
                          lg: "10px 15px",
                        },
                        background: "#1D53E7",
                        color: "#ffffff",
                        textTransform: "none",
                      }}
                    >
                      Start Free Trial
                    </Button>
                    <Button
                      onClick={() =>
                        handlePlanSelect(plan.planName, "Subscribe")
                      }
                      variant="contained"
                      className="btnEnthusiast"
                      fullWidth
                      sx={{
                        backgroundColor: "#C7F760",
                        color: "#1E53E8",
                        p: {
                          xs: "10px 8px",
                          md: "10px 8px",
                          sm: "10px 15px",
                          lg: "10px 15px",
                        },
                        textTransform: "none",
                        transition: "background-color 0.3s, transform 0.3s",

                        "&:hover": {
                          backgroundColor: "#A1D34F",
                          transform: "scale(1.05)",
                          // color: "#1E53E8",
                        },
                        "&:active": {
                          backgroundColor: "#9BCC4E",
                          transform: "scale(1)",
                        },
                      }}
                    >
                      Subscribe Now
                    </Button>
                  </Stack>
                )}
                {plan.planName === "Newbie" && (
                  <Button
                    onClick={() => handlePlanSelect(plan.planName, "Subscribe")}
                    variant="contained"
                    className="btnTxt"
                    fullWidth
                    sx={{
                      textTransform: "none",
                      p: "10px 15px",
                      transition: "background-color 0.3s, transform 0.3s",
                      "&:hover": {
                        backgroundColor: "#A1D34F",
                        transform: "scale(1.05)",
                      },
                      "&:active": {
                        backgroundColor: "#9BCC4E",
                        transform: "scale(1)",
                      },
                    }}
                  >
                    Subscribe Now
                  </Button>
                )}
                {plan.planName === "Pro" && (
                  <Button
                    variant="contained"
                    className="btnTxtDisabled"
                    fullWidth
                    disabled={plan.Availability !== "True"}
                    sx={{
                      textTransform: "none",
                      p: "10px 15px",
                      transition: "background-color 0.3s, transform 0.3s",
                      "&:hover": {
                        backgroundColor: "#A1D34F",
                        transform: "scale(1.05)",
                      },
                      "&:active": {
                        backgroundColor: "#9BCC4E",
                        transform: "scale(1)",
                      },
                    }}
                    onClick={() => handlePlanSelect("Pro")}
                  >
                    {plan.Availability === "True" ? "Subscribe Now" : "Out of Stock"}
                  </Button>
                )}
              </Stack>

              <ul
                className="key-features"
                style={{ textAlign: "left", padding: 0 }}
              >
                {plan.features.map((feature, index) => {
                  // Define the icon order for the "Pro" plan and other plans
                  const proFeatureIcons = [GPU, AMD, GB, CPU, Windows, GBPS];
                  const defaultFeatureIcons = [
                    AMD,
                    GB,
                    CPU,
                    Windows,
                    GBPS,
                    GPU,
                  ];

                  // Choose the icon set based on the plan name
                  const iconSet =
                    plan.planName === "Pro"
                      ? proFeatureIcons
                      : defaultFeatureIcons;

                  return (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "8px",
                        listStyle: "none",
                      }}
                    >
                      <img
                        src={iconSet[index % iconSet.length]} // Use the correct icon set for each plan
                        alt={`Icon for ${feature}`}
                        style={{
                          marginRight: "10px",
                          width: "24px",
                          height: "24px",
                        }}
                      />
                      <span>{feature}</span>
                    </li>
                  );
                })}
              </ul>
            </Card>
          ))}
        </Box>
      </Container>
      <Container
        maxWidth={false}
        sx={{
          backgroundColor: "#F1F1F1",
          padding: {
            xs: "20px 20px",
            sm: "44px 64px",
            md: "68px 68px 86px  64px ",
          },
          zIndex: -2,
          backgroundImage: 'url("/assets/thereMoreForYou.svg")', // Replace with the actual image URL
          backgroundSize: "cover", // Adjust as needed
          backgroundPosition: "center", // Adjust as needed
        }}
      >
        <Stack direction="column" spacing={5}>
          <Typography
            className="heading3"
            sx={{
              textAlign: "center",
            }}
          >
            THERE'S{" "}
            <span style={{ color: "blue" }}>
              <i> MORE </i>
            </span>
            &nbsp; FOR YOU !!
          </Typography>
          <Box
            sx={{
              display: "grid",
              rowGap: 3,
              columnGap: 4,
              // mt: 4,
              gridTemplateColumns: {
                xs: "repeat(1, 1fr)", // iPhone Mini (small screens)
                sm: "repeat(3, 1fr)", // For screens like iPad mini (768px)
                md: "repeat(4, 1fr)",
              },
            }}
          >
            <Stack direction="column" spacing={2}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={KidMonitoringApp}
                  alt="Kid Monitoring App"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "fill",
                  }}
                />
              </Box>
              <Typography className="MoreImgTitle" sx={{ textAlign: "center" }}>
                {" "}
                Kid’s Monitoring App{" "}
              </Typography>
            </Stack>
            <Stack direction="column" spacing={2}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={UpgradeorDowngrade}
                  alt="Upgrade or Downgrade"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "fill",
                  }}
                />
              </Box>
              <Typography className="MoreImgTitle" sx={{ textAlign: "center" }}>
                Upgrade or Downgrade your plan
              </Typography>
            </Stack>
            <Stack direction="column" spacing={2}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={OnDemandBackups}
                  alt="On Demand Backups"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "fill",
                  }}
                />
              </Box>
              <Typography className="MoreImgTitle" sx={{ textAlign: "center" }}>
                {" "}
                On demand backups{" "}
              </Typography>
            </Stack>
            <Stack direction="column" spacing={2}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={SafeSecureEnvironment}
                  alt="Safe Secure Environment"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "fill",
                  }}
                />
              </Box>
              <Typography className="MoreImgTitle" sx={{ textAlign: "center" }}>
                {" "}
                Safe and Secure Environment
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Container>

      <FooterLandingpage />
    </Fragment>
  );
};

export default Plans;
